module.exports = [{
      plugin: require('/Users/tfoster/Documents/GitHub/gatsby-firstwatch-com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
